import { reactive } from 'vue';

export default function useDialogsResource() {
    const releaseDialogs = reactive({
        buttons: [
            {
                id: 'formats',
                label: 'formats',
                icon: 'mdi-disc-player',
                color: 'grey',
                param: 'fo'
            },
            {
                id: 'countries_ac',
                label: 'countries',
                icon: 'mdi-earth',
                color: 'grey',
                param: 'co'
            },
            {
                id: 'my_collections_release',
                label: 'my collections',
                icon: 'mdi-format-list-bulleted',
                color: 'grey',
                param: 'cl'
            },
            {
                id: 'filters',
                label: 'filters',
                icon: 'mdi-filter-cog',
                color: 'grey',
                param: 'fi'
            },
            {
                id: 'date_range',
                label: 'released at',
                icon: 'mdi-calendar-multiselect-outline',
                color: 'grey',
                param: 'dr'
            },
            {
                id: 'sort',
                label: 'sort',
                icon: 'mdi-sort-ascending',
                color: 'grey',
            },
        ],
        visibility: {
            formats: false,
            countries_ac: false,
            my_collections_release: false,
            filters: false,
            sort: false,
            date_range: false,
            date_picker: false,
        },
        sources: {
            sort_options: {
                name_asc: 'alphabet ascending', //divider alphabet
                name_desc: 'alphabet descending', //divider alphabet
                released_desc: 'released descending', //divider day, resource released_at
                released_asc: 'released ascending', //divider day, resource released_at
                format: 'format', //divider format
                country: 'country', //divider country
                updated_at_desc: 'updated descending', //divider month, resource updated_at
                updated_at_asc: 'updated ascending', //divider month, resource updated_at
                cuts_amount_desc: 'cuts descending', //divider cuts seconds, resource cut_status 1 or 2, cut_seconds, cut_details (bool)
                price_avg_desc: 'value descending', //no divider
                price_avg_votes_desc: 'value votes descending', //no divider
            },

            filter_options: {
                //on_my_collections: 'on my collections', //removed because usually this comes with my collection menu
                not_on_my_lists: 'not on my collections',
                pictures_yes: 'only with pictures',
                pictures_no: 'without pictures',
                cut: 'censored releases', //divider cuts seconds, resource cut_status 1 or 2, cut_seconds, cut_details (bool)
                uncut: 'uncensored releases', //resource cut_status 2, cut_seconds, cut_details (bool
                cut_uncut: 'uncensored and censored', //divider cuts seconds, resource cut_status 1 or 2, cut_seconds, cut_details (bool)
                recommended_at: 'recommendations'
                //liked by me
                //added by me
                //contributed by me
            },
            date_range_options: {
                upcoming_release: 'coming soon',
                released_this_month: 'this month',
                released_next_month: 'next month',
                released_last_month: 'last month',
                released_this_year: 'this year',
                released_last_year: 'last year',
                released_selected_date: 'select date range',
            },
        },
        properties: [
            {
                id: 'formats',
                component: 'v-autocomplete',
                label: 'formats',
                param: 'fo',
            },
            {
                id: 'countries_ac',
                component: 'v-autocomplete',
                label: 'countries',
                param: 'co',
            },
            {
                id: 'my_collections_release',
                component: 'v-autocomplete',
                label: 'my collections',
                param: 'cl',
            },
            {
                id: 'sort',
                component: 'v-radio-group',
                title: 'sort',
                param: 'so',
                source: 'sort_options',
            },
            {
                id: 'filters',
                component: 'v-checkbox',
                title: 'filters',
                param: 'fi',
                source: 'filter_options',
            },
            {
                id: 'date_range',
                component: 'v-radio-group',
                title: 'released at',
                param: 'dr',
                source: 'date_range_options',
            },
            {
                id: 'date_picker',
                component: 'v-date-picker',
                title: 'select start end dates',
            },
        ],
        reaction_buttons: [
            {
                id: 'btn1',
                label: 'have it',
                icon: 'mdi-flag-outline',
                active_value: 'owned_count_auth',
                active_value2: 'list_entries_count_auth', //if want to emit double values
                api_route: 'my_owned_collection_toggle',
            },
            {
                id: 'btn2',
                label: 'wanted',
                icon: 'mdi-flag-plus-outline',
                active_value: 'wanted_count_auth',
                active_value2: 'list_entries_count_auth', //if want to emit double values
                api_route: 'my_wanted_collection_toggle',
            },
            {
                id: 'btn3',
                label: 'add to list',
                icon: 'mdi-playlist-plus',
                active_value: 'list_entries_count_auth' //will open user-collections window in UserWidget
            },
            {
                id: 'btn4',
                label: 'like',
                icon: 'mdi-heart-outline',
                active_value: 'likes_count_auth',
                api_route: 'reactions',
            },
        ],
    })

    const movieDialogs = reactive({
        buttons: [
            {
                id: 'countries_ac',
                label: 'countries',
                icon: 'mdi-earth',
                color: 'grey',
                param: 'co'
            },
            {
                id: 'genres',
                label: 'genres',
                icon: 'mdi-alpha-g-box',
                color: 'grey',
                param: 'ge'
            },
            {
                id: 'my_collections_movie',
                label: 'my collections',
                icon: 'mdi-format-list-bulleted',
                color: 'grey',
                param: 'cl'
            },
            {
                id: 'filters',
                label: 'filters',
                icon: 'mdi-filter-cog',
                color: 'grey',
                param: 'fi'
            },
            {
                id: 'decades',
                label: 'decades',
                icon: 'mdi-calendar-multiselect-outline',
                color: 'grey',
                param: 'de'
            },
            {
                id: 'sort',
                label: 'sort',
                icon: 'mdi-sort-ascending',
                color: 'grey',
            },
        ],
        visibility: {
            countries_ac: false,
            genres: false,
            my_collections_movie: false,
            filters: false,
            sort: false,
            decades: false,
            date_range: false,
            date_picker: false,
            person_role: false,
        },
        sources: {
            sort_options: {
                name_asc: 'alphabet ascending', //divider alphabet
                name_desc: 'alphabet descending', //divider alphabet
                released_desc: 'released descending', //divider day, resource released_at
                released_asc: 'released ascending', //divider day, resource released_at
                releases_desc: 'releases descending',
                ratings_desc: 'highest rated',
                reviews_desc: 'most reviewed',
                likes_desc: 'most liked',
                updated_at_desc: 'updated descending', //divider month, resource updated_at
                updated_at_asc: 'updated ascending', //divider month, resource updated_at
                random: 'random sort', //no divider
            },

            filter_options: {
                upcoming: 'coming soon', //whereNotNull('released_at')->where('released_at', '<', Carbon::now()) divider day, resource released_at
                reviewed: 'has reviews', //has reviews
                you_reviewed: 'your review', //you have reviewed
                you_liked: 'you liked', //you have liked
                tv_series: 'movie type 2', //tv series type 2
                tv_episode: 'movie type 5', //tv episode type 5
            },
        },
        properties: [
            {
                id: 'countries_ac',
                component: 'v-autocomplete',
                label: 'countries',
                param: 'co',
            },
            {
                id: 'genres',
                component: 'v-autocomplete',
                label: 'genres',
                param: 'ge',
            },
            {
                id: 'my_collections_movie',
                component: 'v-autocomplete',
                label: 'my collections',
                param: 'cl',
            },
            {
                id: 'sort',
                component: 'v-radio-group',
                title: 'sort',
                param: 'so',
                source: 'sort_options',
            },
            {
                id: 'filters',
                component: 'v-checkbox',
                title: 'filters',
                param: 'fi',
                source: 'filter_options',
            },
            {
                id: 'decades',
                component: 'v-autocomplete',
                label: 'decades',
                param: 'de',
                source: 'decades',
            },
        ],
    })

    const reviewDialogs = reactive({
        reaction_buttons: [
            {
                id: 'btn4',
                label: 'like',
                icon: 'mdi-heart-outline',
                active_value: 'likes_count_auth',
                api_route: 'reactions',
            },
        ],
    })

    return {
        releaseDialogs,
        movieDialogs,
        reviewDialogs,
    }
}
